// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b87664d7","453":"8133ed21","455":"11999fc1","977":"fdf213fe"}[chunkId] + ".chunk.js";
};